export const isValidEmail = (email: string): boolean => {
  const emailRegex = new RegExp(
    "\\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Z|a-z]{2,}\\b",
  );
  return emailRegex.test(email);
};
